export const INFORMATIONAL_MESSAGE_VARIANTS = {
  info: 'info',
  error: 'error',
  warning: 'warning',
  default: 'default',
} as const
